export const phones = [
  {
    title: "Apple iPhone 7 Plus 32 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/18/280-413/9801258663986.jpg?v1",
      "https://productimages.hepsiburada.net/s/18/280-413/9801258696754.jpg?v1",
      "https://productimages.hepsiburada.net/s/18/280-413/9801258729522.jpg?v1",
      "https://productimages.hepsiburada.net/s/18/280-413/9801258762290.jpg?v1"
    ],
    brand: "apple",
    price: 4241.499828399639,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 0,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Huawei Mate 20 Lite 64 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/21/280-413/9933217792050.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217628210.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217660978.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217693746.jpg?v1"
    ],
    brand: "huawei",
    price: 1823.6625483451157,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 1,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Huawei P20 Lite 64 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/19/280-413/9826975907890.jpg?v1",
      "https://productimages.hepsiburada.net/s/19/280-413/9826975940658.jpg?v1",
      "https://productimages.hepsiburada.net/s/19/280-413/9826975973426.jpg?v1",
      "https://productimages.hepsiburada.net/s/19/280-413/9826976006194.jpg?v1"
    ],
    brand: "huawei",
    price: 7429.467511354926,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 2,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy A7 2018 64 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/22/280-413/9946187399218.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9946187431986.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9946187464754.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9946187497522.jpg?v1"
    ],
    brand: "samsung",
    price: 4108.082941215698,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 5,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy J6 Plus 32 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/22/280-413/9941129494578.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9941129527346.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9941129560114.jpg?v1",
      "https://productimages.hepsiburada.net/s/22/280-413/9941129592882.jpg?v1"
    ],
    brand: "samsung",
    price: 4260.9529075338505,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 6,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Apple iPhone 7 32 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/1/280-413/9502147641394.jpg?v1",
      "https://productimages.hepsiburada.net/s/1/280-413/9502147674162.jpg?v1",
      "https://productimages.hepsiburada.net/s/1/280-413/9502147706930.jpg?v1",
      "https://productimages.hepsiburada.net/s/1/280-413/9502147739698.jpg?v1"
    ],
    brand: "apple",
    price: 1525.6236967422828,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 10,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy S10 Plus 128 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/25/280-413/10107992703026.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107992735794.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107992768562.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107992801330.jpg?v1"
    ],
    brand: "samsung",
    price: 3429.3471420603028,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 11,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy S10 128 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/25/280-413/10107307425842.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307458610.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307491378.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307524146.jpg?v1"
    ],
    brand: "samsung",
    price: 1017.7877018963508,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 12,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy S10e 128 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/25/280-413/10107307032626.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307065394.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307098162.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10107307130930.jpg?v1"
    ],
    brand: "samsung",
    price: 3235.202225041739,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 13,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy M20 32 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/25/280-413/10094999240754.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10094999273522.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10094999306290.jpg?v1",
      "https://productimages.hepsiburada.net/s/25/280-413/10094999339058.jpg?v1"
    ],
    brand: "samsung",
    price: 5850.5748675199875,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 14,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy S8",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/3/280-413/9604775739442.jpg?v1",
      "https://productimages.hepsiburada.net/s/4/280-413/9665566703666.jpg?v1",
      "https://productimages.hepsiburada.net/s/4/280-413/9665566736434.jpg?v1",
      "https://productimages.hepsiburada.net/s/4/280-413/9665566769202.jpg?v1"
    ],
    brand: "samsung",
    price: 3207.2840718201587,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 15,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Huawei P Smart 2019 64 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/23/280-413/10059934859314.jpg?v1",
      "https://productimages.hepsiburada.net/s/23/280-413/10059934892082.jpg?v1",
      "https://productimages.hepsiburada.net/s/23/280-413/10059934924850.jpg?v1",
      "https://productimages.hepsiburada.net/s/23/280-413/10059934957618.jpg?v1"
    ],
    brand: "huawei",
    price: 5288.552334214134,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 16,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Apple iPhone 6S Plus 32 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/1/280-413/9489589993522.jpg?v1",
      "https://productimages.hepsiburada.net/s/1/280-413/9489589927986.jpg?v1",
      "https://productimages.hepsiburada.net/s/1/280-413/9489589960754.jpg?v1"
    ],
    brand: "apple",
    price: 5467.082548922358,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 18,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Samsung Galaxy Note 9 128 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/20/280-413/9902572142642.jpg?v1",
      "https://productimages.hepsiburada.net/s/20/280-413/9902572175410.jpg?v1",
      "https://productimages.hepsiburada.net/s/20/280-413/9902572208178.jpg?v1",
      "https://productimages.hepsiburada.net/s/20/280-413/9902572240946.jpg?v1"
    ],
    brand: "samsung",
    price: 1165.0255199945123,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 22,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  },
  {
    title: "Huawei Mate 20 Lite Dual Sim 64 GB",
    category: "phone",
    images: [
      "https://productimages.hepsiburada.net/s/21/280-413/9933217792050.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217660978.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217693746.jpg?v1",
      "https://productimages.hepsiburada.net/s/21/280-413/9933217726514.jpg?v1"
    ],
    brand: "huawei",
    price: 2693.4407990587074,
    cpu: "1.3GHz Apple A6",
    camera: "8mp (3264x2448)",
    size: "124.4mm x 59.2mm x 8.97mm (4.9 x 2.33 x 0.35)",
    weight: "132 grams (4.7 ounces) with battery",
    display: "4.0 326 pixel density",
    battery: "1480 mAh",
    memory: "16GB, 32GB and RAM 1 GB",
    id: 23,
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet numquam aspernatur!"
  }
];
